import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { MaintenanceService } from '../../services/maintenance.service';

const POLL_INTERVAL_MS = 60 * 1000;

@Component({
	selector: 'app-maintenance',
	templateUrl: './maintenance.component.html'
})
export class MaintenanceComponent implements OnInit, OnDestroy {
	checking = false;

	private pollSubscription?: Subscription;

	constructor(public maintenanceService: MaintenanceService) {}

	get etaText(): string | null {
		const eta = this.maintenanceService.eta;

		return eta ? eta.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }) : null;
	}

	ngOnInit(): void {
		// Landed here directly (refresh/bookmark) — find out whether we're actually down.
		if (!this.maintenanceService.mode) {
			this.check();
		}

		this.pollSubscription = interval(POLL_INTERVAL_MS).subscribe(() => this.check());
	}

	ngOnDestroy(): void {
		this.pollSubscription?.unsubscribe();
	}

	check(): void {
		this.checking = true;

		this.maintenanceService.probe().subscribe((response) => {
			this.checking = false;

			if (response.status === 200) {
				this.maintenanceService.recover();
				return;
			}

			this.maintenanceService.applyProbeResult(response);
		});
	}
}
